import { ENGLISH_IQ_SUB_BANDS } from '../../learning';

const minimumScore: number = ENGLISH_IQ_SUB_BANDS[0].minScore;
const maximumScore: number = ENGLISH_IQ_SUB_BANDS.at(-1)?.maxScore ?? minimumScore;

export const ENGLISH_IQ_RESULT_IMG_SCORES: readonly number[] = Object.freeze(
  Array.from({ length: maximumScore - minimumScore + 1 }, (_, index) => index + minimumScore),
);
